module.exports = __webpack_public_path__ + "img/points_calc_ch.75c591c7.png";